import React, { PureComponent } from 'react';
import { FacebookProvider, Page } from 'react-facebook';

import './Actu.css';

class Actu extends PureComponent {
  constructor() {
    super();
    this.state = {
      posts: [],
    };
  }

  componentDidMount() {}

  render() {
    return (
      <FacebookProvider appId="811414682550666" language="fr_FR">
        <Page
          href="https://www.facebook.com/BIERESLEBAIGNEUR"
          tabs="timeline"
          className="lalala"
        />
      </FacebookProvider>
    );
  }
}

export default Actu;



// WEBPACK FOOTER //
// ./src/Components/Actu/Actu.js